import Dropzone from 'react-dropzone';
import styled from 'styled-components';

export const StyledDropzone = styled(Dropzone)`
  width: 100%;
  height: 48px;
  border-radius: 10px;
  cursor: pointer;
  margin-block: 0.5rem 1rem;
  border: 2px dashed gray;
  background-color: #f5f5f5;
  padding: 0rem;
`;

export const DragDropFilePickerContent = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  //top: 50%;
  width: 100%;
  text-align: center;
  align-items: center;
  & > p {
    margin: 10px;
  }
  //transform: translateY(-50%);
  //padding-top: 0.5rem;
`;

export const DragDropFilePickerContentText = styled.p`
  font-size: 12px;
`;
